import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  height: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ag-theme-alpine {
    flex: 1 1 0px;
    width: 100%;
    height: 100%;
  }

  .ag-pivot-mode-panel {
    display: none;
  }
`

export default Styled
